import { create } from 'zustand';
import type { ToastData, ToastTone } from '@/components/ui/toast';

type ToastState = {
  toasts: ToastData[];
  push: (tone: ToastTone, message: string) => void;
  dismiss: (id: string) => void;
};

const DEFAULT_DURATION_MS = 2500;

export const useToastStore = create<ToastState>((set, get) => ({
  toasts: [],
  push: (tone, message) => {
    const id = crypto.randomUUID();
    set((s) => ({ toasts: [...s.toasts, { id, tone, message }] }));
    setTimeout(() => get().dismiss(id), DEFAULT_DURATION_MS);
  },
  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}));
